import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Accounts`}</h2>
    <ProjectCard title="YouTube" link="https://www.youtube.com/channel/UCi6VkPnL8sh_9wvu7ndDZig" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Here's my YouTube channel, where I upload (or, rather, uploaded) random videos of me playing video games and stuff. Planning to start a new one soon, but for now, this is it.
    </ProjectCard>
    <ProjectCard title="Instagram" link="https://www.instagram.com/_rhythmik/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
My music reviewing Instagram account, which I'm just getting off the ground currently! 
    </ProjectCard>
    <ProjectCard title="Steam" link="https://steamcommunity.com/id/smtcubes/" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
My steam account- feel free to friend me if you have Steam! We can maybe play Fall Guys together or something 😳
    </ProjectCard>
    <ProjectCard title="Reddit" link="https://www.reddit.com/user/SMTCubes" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
keanu chungus wholesome 100
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      